import { PropType } from 'vue';
import { Options, Vue } from 'vue-class-component';
import { ApartmentLabelDTO } from '@/../client-generator/generated-clients/plants';

@Options({
  name: 'DialogShareCode',
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['hide-dialog', 'share-email'],
})

export default class DialogShareCode extends Vue {
  email = "";
  isVisible!: boolean;

  handleHideDialog() {
    this.$emit('hide-dialog');
  }

  get saveButtonDisabled() {
    //TODO implementare share
    return true;
  }

  async handleButtonSubmitAction() {
    this.$emit('share-email', this.email);
  }
}
